import { combineReducers } from "@reduxjs/toolkit";

import type { CoachmarkDomainAction } from "domains/coachmarks/actionTypes";
import { CoachmarkDomainsActionType } from "domains/coachmarks/actionTypes";
import type { CoachmarkDomainState } from "domains/coachmarks/types";
import { addUserOrLanguageChangeReset } from "entities/topics/reducerHelpers";

const initialState: CoachmarkDomainState = {
  isEnabled: null,
  usedIds: [],
  inDOMIds: [],
};

const isEnabled = (
  state = initialState.isEnabled,
  action: CoachmarkDomainAction,
): CoachmarkDomainState["isEnabled"] => {
  switch (action.type) {
    case CoachmarkDomainsActionType.TOGGLE:
      return !state;
    case CoachmarkDomainsActionType.FETCH_VISIBILITY_STATUS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const usedIds = (state = initialState.usedIds, action: CoachmarkDomainAction): CoachmarkDomainState["usedIds"] => {
  switch (action.type) {
    case CoachmarkDomainsActionType.ADD_TO_USED:
    case CoachmarkDomainsActionType.FETCH_USED_SUCCESS:
      return action.payload?.ids ? [...state, ...action.payload.ids.filter((id) => !state.includes(id))] : state;

    case CoachmarkDomainsActionType.REMOVE_FROM_USED:
      return action.payload?.ids ? state.filter((item) => !action.payload?.ids.includes(item)) : [];

    default:
      return state;
  }
};

const inDOMIds = (state = initialState.inDOMIds, action: CoachmarkDomainAction): CoachmarkDomainState["inDOMIds"] => {
  switch (action.type) {
    case CoachmarkDomainsActionType.ADD_TO_IN_DOM:
      return action.payload?.ids || [];
    default:
      return state;
  }
};

export const coachmarksReducer = combineReducers({
  isEnabled,
  usedIds,
  inDOMIds: addUserOrLanguageChangeReset(inDOMIds, initialState.inDOMIds),
});
